import { Conversation } from '@/hooks/useChat';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Plus, Trash2 } from 'lucide-react';
import { motion } from 'framer-motion';

interface ConversationListProps {
  conversations: Conversation[];
  currentId: string | null;
  onNew: () => void;
  onSelect: (id: string) => void;
  onDelete: (id: string) => void;
}

export function ConversationList({
  conversations,
  currentId,
  onNew,
  onSelect,
  onDelete,
}: ConversationListProps) {
  return (
    <div className="flex flex-col h-full bg-slate-950 border-r border-slate-800">
      <div className="p-4 border-b border-slate-800">
        <Button
          onClick={onNew}
          className="w-full bg-cyan-600 hover:bg-cyan-700 gap-2"
        >
          <Plus className="w-4 h-4" />
          New chat
        </Button>
      </div>

      <ScrollArea className="flex-1">
        <div className="p-3 space-y-2">
          {conversations.length === 0 ? (
            <p className="text-xs text-slate-500 text-center py-8">
              No conversations yet
            </p>
          ) : (
            conversations.map((conv) => (
              <motion.div
                key={conv.id}
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -10 }}
                className="group"
              >
                <button
                  onClick={() => onSelect(conv.id)}
                  className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${
                    currentId === conv.id
                      ? 'bg-slate-800 text-white'
                      : 'text-slate-300 hover:bg-slate-800'
                  }`}
                >
                  <p className="truncate font-medium">{conv.title}</p>
                  <p className="text-xs text-slate-500 mt-0.5">
                    {conv.messages.length} messages
                  </p>
                </button>
                <button
                  onClick={() => onDelete(conv.id)}
                  className="hidden group-hover:block absolute right-2 top-2 p-1 rounded hover:bg-slate-700 text-slate-400 hover:text-red-400"
                >
                  <Trash2 className="w-3 h-3" />
                </button>
              </motion.div>
            ))
          )}
        </div>
      </ScrollArea>
    </div>
  );
}
